import {useCallback,useEffect,useRef,useState} from 'react';

const entries=new Map(),listeners=new Set();
const lifetime=60000,limit=80;
export function invalidateWorkspaceMemory(){entries.clear();}
export function clearWorkspaceMemory(){
 entries.clear();
 for(const listener of listeners)listener();
}
function read(key){
 const entry=entries.get(key);
 if(!entry||Date.now()-entry.at>=lifetime){entries.delete(key);return null;}
 entries.delete(key);entries.set(key,entry);
 return entry;
}
function remember(key,value){
 entries.delete(key);entries.set(key,{value,at:Date.now()});
 while(entries.size>limit)entries.delete(entries.keys().next().value);
}
// RAM only. A fresh authorized request always runs on page entry.
// Never use remembered data to authorize a payment or security mutation.
export function useRememberedState(scope,name,initial,canRemember=value=>value!=null){
 const key=JSON.stringify([scope,name]),initialRef=useRef(initial),valid=useRef(canRemember);
 initialRef.current=initial;valid.current=canRemember;
 const [entry,setEntry]=useState(()=>{const old=read(key);return {key,value:old?old.value:initial,cached:!!old};});
 const current=entry.key===key?entry:{key,value:read(key)?.value??initial,cached:true};
 useEffect(()=>{
  if(entry.key!==key){const old=read(key);setEntry({key,value:old?old.value:initialRef.current,cached:!!old});}
 },[key,entry.key]);
 useEffect(()=>{
  const reset=()=>setEntry({key,value:initialRef.current,cached:false});
  listeners.add(reset);return()=>listeners.delete(reset);
 },[key]);
 useEffect(()=>{
  if(entry.key===key&&!entry.cached){if(valid.current(entry.value))remember(key,entry.value);else if(entry.value==null)entries.delete(key);}
 },[entry,key]);
 const setValue=useCallback(next=>setEntry(old=>{
  const previous=old.key===key?old.value:read(key)?.value??initialRef.current;
  return {key,value:typeof next==='function'?next(previous):next,cached:false};
 }),[key]);
 return [current.value,setValue,current.cached];
}
